<div class="content">
<mat-card appearance="outlined">
    <mat-card-header>
        <mat-icon class="card-header-icon" mat-card-avatar>error</mat-icon>
        <mat-card-title>Error Log</mat-card-title>
        <mat-card-subtitle>List of errors across client, server and transform engine</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="width: 100%">
        <button mat-button color="primary" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Go Back
        </button>
        <div style="margin-top: 5px; display: flex; width: 100%; align-content: flex-end; ">
            <mat-progress-bar *ngIf="isGettingData | async" style="margin-left: auto; width: 200px;"
                mode="indeterminate"></mat-progress-bar>
        </div>

        <mat-paginator #topPaginator (page)="onPageChanged($event, topPaginator)" *ngIf="dataSource"
            [length]="totalRows" [pageSize]="rowsPerPage" [pageSizeOptions]="pageSizeOptions">
        </mat-paginator>

        <h1 style="color: lightgray" *ngIf="!dataSource" class="center">{{(isGettingData | async) ? "Please wait..." :
            noDataTitle}}</h1>
        <div style="overflow-y: auto; width:100%; overflow-x: auto;">

            <table mat-table *ngIf="dataSource" [dataSource]="dataSource" class="mat-elevation-z8">

                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
                    <mat-cell *matCellDef="let report"> {{report.errorReportId}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="createdDateTime">
                    <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                    <mat-cell *matCellDef="let report"> {{report.createdDateTime}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="errorType">
                    <mat-header-cell *matHeaderCellDef> Error Type </mat-header-cell>
                    <mat-cell *matCellDef="let report"> {{report.errorType}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="errorMessage">
                    <mat-header-cell *matHeaderCellDef> Error </mat-header-cell>
                    <mat-cell *matCellDef="let report"> {{report.errorMessageTruncated}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="applicationId">
                    <mat-header-cell *matHeaderCellDef> Application </mat-header-cell>
                    <mat-cell *matCellDef="let report"> {{report.applicationName}} </mat-cell>
                </ng-container>
                
                <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    
                <mat-row
                    class="drag-component"
                    style="cursor: pointer;" 
                    (click)="showErrorDetail(report)"
                    *matRowDef="let report; columns: columnsToDisplay;">
                </mat-row>
            </table>
        </div>

        <mat-paginator #bottomPaginator (page)="onPageChanged($event, bottomPaginator)" *ngIf="dataSource"
            [length]="totalRows" [pageSize]="rowsPerPage" [pageSizeOptions]="pageSizeOptions">
        </mat-paginator>
    </mat-card-content>
</mat-card>
</div>